/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type BuyMobileNav_user = {
    readonly " $fragmentRefs": FragmentRefs<"SbMobileAppliedFilters_user" | "BuyMobileNavRefineMenuFilters_user">;
    readonly " $refType": "BuyMobileNav_user";
};
export type BuyMobileNav_user$data = BuyMobileNav_user;
export type BuyMobileNav_user$key = {
    readonly " $data"?: BuyMobileNav_user$data;
    readonly " $fragmentRefs": FragmentRefs<"BuyMobileNav_user">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuyMobileNav_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbMobileAppliedFilters_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BuyMobileNavRefineMenuFilters_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = '0771884fad1c66618474f3286aafcba1';
export default node;
